module.exports = __webpack_public_path__ + "img/cross.e7f45da6.svg";